import { Grid, TextField } from '@mui/material';
import { AnnotationAssignmentAutocomplete } from 'components/atoms/AnnotationAssignmentAutocomplete';
import { MULTIPLEX_STAIN_ID } from 'interfaces/stainType';
import { get, map } from 'lodash';
import { default as React } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { CasesParams } from 'utils/useCasesParams/types';
import { ChannelsController } from '../../ChannelsController';
import { QaAnalysisFormValues } from './types';

export interface AdditionalParametersStepProps {
  methods: UseFormReturn<QaAnalysisFormValues, any>;
  checkValidationAndSetIsStepFailed: () => void;
  casesParams: CasesParams;
}

export const AdditionalParametersStep: React.FC<AdditionalParametersStepProps> = ({
  methods,
  checkValidationAndSetIsStepFailed,
  casesParams,
}) => {
  const {
    control,
    watch,
    formState: { errors },
  } = methods;

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <ChannelsController
          name="configParams.markers"
          error={Boolean(get(errors, 'configParams.markers'))}
          helperText={get(errors, 'configParams.markers')?.message}
          methods={methods}
          additionalOnChange={() => {
            checkValidationAndSetIsStepFailed();
          }}
          casesParams={casesParams}
        ></ChannelsController>
      </Grid>

      <Grid item>
        <Controller
          control={control}
          name="configParams.assignmentIds"
          render={({ field: { onChange, value } }) => (
            <AnnotationAssignmentAutocomplete
              multiple
              casesParams={casesParams}
              slideStainType={MULTIPLEX_STAIN_ID}
              selectedValue={value || []}
              onChange={(event, newValue) => {
                onChange(map(newValue, (assignment) => assignment.annotationAssignmentId));
                checkValidationAndSetIsStepFailed();
              }}
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Annotation assignments"
                  error={Boolean(get(errors, 'configParams.assignmentIds'))}
                  helperText={get(errors, 'configParams.assignmentIds')?.message}
                />
              )}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
